<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.73807 14.9722C9.14115 15.6687 8.00001 15.2465 8.00001 14.3293C8.00001 14.1155 8.06934 13.9075 8.1976 13.7365L11 10L8.1976 6.26345C8.06935 6.09244 8.00001 5.88445 8.00001 5.67069C8.00001 4.75347 9.14115 4.33133 9.73807 5.02773L14 9.99998L9.73807 14.9722Z"
    fill="currentColor"
  />
</svg>
